import React from "react";
import "./searchbar.css";

export default function Searchbar() {
  return (
    <div className="sidebar_extension__searchbar">
      <input type="text" placeholder="Search" />
      <img src="/assets/icons/search-icon.svg" className="search-icon" />
    </div>
  );
}
